import "./App.scss";

import { Route, Switch } from "react-router-dom";
import { getFirestore } from "firebase/firestore";
import {
  AuthProvider,
  DatabaseProvider,
  FirestoreProvider,
  useFirebaseApp,
} from "reactfire";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

import LandingPage from "./pages/LandingPage/LandingPage";
import LiveLocal from "./pages/LiveLocal/LiveLocal";
import Experience from "./pages/Experience/Experience";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import AuthMenuMobile from "./pages/Auth/AuthMenuMobile";

import Moments from "./pages/Moments/Moments";
import Rooms from "./pages/Rooms/Rooms";
import TheBigOne from "./pages/RoomsPages/TheBigOne/TheBigOne";
import AuthCreate from "./pages/Auth/AuthCreate/AuthCreate";
import AuthLogin from "./pages/Auth/AuthLogin/AuthLogin";
import AuthLoginCreate from "./pages/Auth/AuthLoginCreate/AuthLoginCreate";
import Careers from "./pages/Careers/Careers";
import ContactUs from "./pages/ContactUs/ContactUs";
import Events from "./pages/Events/Events";
import FAQs from "./pages/FAQs/FAQs";
import FoodAndDrinks from "./pages/FoodAndDrinks/FoodAndDrinks";
import Neighbourhood from "./pages/Neighbourhood/Neighbourhood";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";
import AuthAccount from "./pages/Auth/AuthAccount/AuthAccount";
import AuthLoginSecurity from "./pages/Auth/AuthLoginSecurity/AuthLoginSecurity";
import AuthMyBookings from "./pages/Auth/AuthMyBookings/AuthMyBookings";
import AuthPaymentInformation from "./pages/Auth/AuthPaymentInformation/AuthPaymentInformation";
import AuthSpecialOffers from "./pages/Auth/AuthSpecialOffers/AuthSpecialOffers";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import AppContext from "./context";
import { useWindowSize } from "./hooks/useWindowSize";
import ScrollToTop from "./ScrollToTop";
import {
  OLIVE_BOOKING_PATH,
  getOliveBookingHash,
} from "./util/olive";
import Blog from "./pages/Blog/Blog";
import BlogDetail from "./pages/Blog/BlogDetail";

function App() {
  const windowSize = useWindowSize();
  const firestoreInstance = getFirestore(useFirebaseApp());
  const app = useFirebaseApp();
  const database = getDatabase(app);
  const auth = getAuth(app);

  // Olive is the site's only booking engine. Every "Book Now" entry point calls
  // this, which hands the trip to Olive's widget on the rooms page.
  //
  // This is a full page load, not a router push, and deliberately so: Olive's
  // own trip pill navigates the same way. On a client-side route change its
  // bootstrap runs removeOliveWidget(), which detaches #olive-root without
  // unmounting the React root living inside it, then mounts a second root
  // 1200ms later. The orphaned root keeps committing into a detached tree and
  // throws "NotFoundError: Failed to execute 'removeChild'", leaving the
  // booking widget dead until the guest reloads. A fresh document sidesteps
  // that entirely.
  const openBookingEngine = (startDate?: Date, endDate?: Date) => {
    window.location.assign(
      `${OLIVE_BOOKING_PATH}${getOliveBookingHash(startDate, endDate)}`
    );
  };

  return (
    <FirestoreProvider sdk={firestoreInstance}>
      <AuthProvider sdk={auth}>
        <DatabaseProvider sdk={database}>
          <AppContext.Provider
            value={{
              size: windowSize,
              openBookingEngine,
            }}
          >
            {/* <BrowserRouter> */}
            <Header />
            <AuthMenuMobile />
            <ScrollToTop />
            <Switch>
              <Route path="/" exact component={LandingPage} />
              <Route path="/live-local" exact component={LiveLocal} />
              <Route path="/experience" exact component={Experience} />
              <Route path="/create" exact component={AuthCreate} />
              <Route path="/login" exact component={AuthLogin} />
              <Route path="/login-create" exact component={AuthLoginCreate} />
              <Route path="/mybookings" exact component={AuthMyBookings} />
              <Route
                path="/specialoffers"
                exact
                component={AuthSpecialOffers}
              />
              <Route path="/account" exact component={AuthAccount} />
              <Route
                path="/loginsecurity"
                exact
                component={AuthLoginSecurity}
              />
              <Route
                path="/paymentinformation"
                exact
                component={AuthPaymentInformation}
              />
              <Route path="/camera-roll" exact component={Moments} />
              <Route path="/rooms" exact component={Rooms} />
              <Route path="/rooms/:id" exact component={TheBigOne} />
              <Route path="/careers" exact component={Careers} />
              <Route path="/contact-us" exact component={ContactUs} />
              <Route path="/events" exact component={Events} />
              <Route path="/faqs" exact component={FAQs} />
              <Route path="/eat-and-drink" exact component={FoodAndDrinks} />
              <Route path="/neighbourhood" exact component={Neighbourhood} />
              <Route path="/privacy-policy" exact component={PrivacyPolicy} />
              <Route path="/the-lobby" exact component={Blog} />
              <Route path="/the-lobby/:id" exact component={BlogDetail} />
              <Route
                path="/terms-and-conditions"
                exact
                component={TermsAndConditions}
              />
              <Route component={NotFoundPage} />
            </Switch>
            <Footer />
            {/* </BrowserRouter> */}
          </AppContext.Provider>
        </DatabaseProvider>
      </AuthProvider>
    </FirestoreProvider>
  );
}

export default App;
